import React, { useState, useEffect, useContext } from 'react';
import AddReminderWizardView from '../view/AddReminderWizardView';
import GeneralContext from '../../GeneralContext';

const defaultRemindersData = {
  status: {
    jobType: 'form_reminders',
    isActive: false,
    action: 'form_reminders',
    who: 'submitter',
    whoSpecificIds: [],
    condition: {
      conditionType: 'status',
      interval: 30,
      intervalUnit: 'day',
      statusList: []
    }
  },
  date: {
    jobType: 'form_reminders',
    isActive: false,
    action: 'form_reminders',
    who: 'submitter',
    whoSpecificIds: [],
    condition: {
      conditionType: 'date',
      dateOperator: 'after',
      interval: 30,
      intervalUnit: 'day'
    }
  }
};

const AddReminderWizardEngine = ({ open, handleClose }) => {
  const api = useContext(GeneralContext);
  const { validateReminderTitle, addNewReminder, form } = api;
  //   const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);
  const [reminderType, setReminderType] = useState('date');
  const [reminderTitle, setReminderTitle] = useState('');
  const [isWizardDirty, setIsWizardDirty] = useState(false);
  const [showTitleError, setShowTitleError] = useState(false);

  useEffect(() => {
    if (!open) {
      // reset form
      setReminderType('date');
      setReminderTitle('');
      setIsWizardDirty(false);
      setShowTitleError(false);
    }
  }, [open]);

  const validateData = () => {
    if (validateReminderTitle(reminderTitle)) {
      const reminderData = defaultRemindersData[reminderType];
      if (reminderType === 'status') {
        reminderData.condition.statusList[0] =
          form.customStatuses[0].internalId; // Need to make sure [0] is position 0 as well
      }
      reminderData.assetId = form.id;
      reminderData.title = reminderTitle;
      reminderData.metadata = {};

      addNewReminder(reminderData);
      handleClose();
    } else {
      setShowTitleError(true);
    }
  };

  const viewProps = {
    open,
    handleConfirm: validateData,
    // isConfirmDisabled,
    reminderType,
    setReminderType,
    reminderTitle,
    setReminderTitle,
    handleClose,
    isWizardDirty,
    setIsWizardDirty,
    showTitleError,
    setShowTitleError
  };

  return <AddReminderWizardView {...viewProps} />;
};

export default AddReminderWizardEngine;
